<template>
  <div class="bar-options-data-dialog colorfff6">
    <div class="setting-item">
      <div class="content" v-show="checkType(seriesDataDimensionOne)">
        <el-collapse v-model="activeNames">
          <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
            <div class="data-source-type">
              <cx-slider :value.sync="isLocal" :options="dataOptions" :height="32" />
            </div>
            <data-center-choose
              v-show="!isLocal"
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              class="mt12"
              type="chart_screen"
              @onDataCenterChange="onDataCenterChange"
              @onAfterDataCenterChoose="onAfterDataCenterChoose"
              @onBeforeDataCenterUpdate="onBeforeDataCenterUpdate"
              @onAfterDataCenterUpdate="onAfterDataCenterUpdate"
            />
            <div v-show="isLocal" class="dataSource-item mt12" @click="goToChooseData">
              <span>进入数据管理后台 </span>
            </div>
          </el-collapse-item>
          <el-collapse-item
            v-if="isLocal"
            class="dataContent"
            @mousedown.native="collapseMouseDown($event, '2')"
            title="数据内容"
            name="2"
          >
            <series-data
              v-if="options.chartOption.series.length > 0 && isLocal"
              :options="options"
              :seriesDataDimensionOne="seriesDataDimensionOne[activeIndex]"
              :seriesDataDimensionTwo="seriesDataDimensionTwo"
              :index="activeIndex"
              :defaultColor="defaultColor"
              :defaultGradientColor="defaultGradientColor"
            ></series-data>
            <!--            水球,刻度图，3d饼图 不支持添加多组数据-->
            <div class="dataTabs" v-if="isDisableAddClassification && options.chartOption.series.length > 0 && isLocal">
              <div class="addClassification" v-if="barStyleId !== 12" @click="addClassification()"><div class="icon icon-portal-icon-add"></div></div>
              <div
                v-for="(tab, index1) in seriesDataDimensionOne"
                :key="index1"
                :class="activeIndex === index1 ? 'dataTabItem active' : 'dataTabItem'"
                @click.stop="activeTabData(index1)"
              >
                <input
                  v-if="editingFlag && activeIndex === index1"
                  v-focus
                  class="data-editor"
                  @change="renameSeriesDataHandle(index1, tab.name)"
                  v-model="tab.name"
                />
                <div v-else>
                  <span class="value-viewer overflowHid1">{{ tab.name }}</span>
                  <span class="icon icon-portal-down-one fs12"></span>
                </div>
                <div v-if="activeIndex === index1 && oprateShow && barStyleId !== 12" class="dataTableOperate">
                  <ul>
                    <li class="dataTableOperate_item" @click="showRenameSeriesDataHandle">重命名</li>
                    <li class="dataTableOperate_item" @click="deleteSeriesDataHandle">删除</li>
                    <li class="dataTableOperate_item" @click="moveSeriesDataHandle(1, index1)">左移</li>
                    <li class="dataTableOperate_item" @click="moveSeriesDataHandle(2, index1)">右移</li>
                  </ul>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item
            v-show="!isLocal"
            @mousedown.native="collapseMouseDown($event, '3')"
            title="更多"
            name="3"
          >
            <auto-update-timer type="chart_screen" />
            <div v-if="request_prefix==='bigScreen'" class="mt12">
              <cx-check-box :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
            </div>
            <div v-if="options.type === 'LiquidFill'">
              <cx-check-box :value.sync="maxAutoSet">自定义max值</cx-check-box>
              <single-input v-if="maxAutoSet" class="mt8 w100_60" :value.sync="maxAutoValue" :min="0" :noInputSuffixs="true"/>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import SeriesData from "./options/seriesData"
import allChartDataHandle from "utils/updateData/chart/index.js"
// 引入默认柱状图
import { chartOption1 } from "materials/bigScreen/bar/menus/difference_options/allTypeCharOptions/chartOption1"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "chart-common-options-data",
  components: { SeriesData, autoUpdateTimer, dataCenterChoose },
  props: {
    options: Object
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
      interval: 3,
      activeIndex: 0,
      editingFlag: false,
      oprateShow: false,
      defaultColor: [
        "rgb(0, 71, 255)",
        "rgb(0, 228, 228)",
        "rgb(255, 166, 63)",
        "rgb(214, 39, 176)",
        "rgb(192, 53, 227)",
        "rgb(128, 44, 245)",
        "rgb(139, 255, 74)",
        "rgb(255, 164, 41)",
        "rgb(255, 92, 90)",
        "rgb(255, 88, 199)",
        "rgb(83, 255, 172)",
        "rgb(255, 249, 31)",
        "rgb(65, 255, 209)",
        "rgb(109, 92, 255)",
        "rgb(0, 137, 255)",
        "rgb(255, 105, 105)",
        "rgb(131, 255, 125)",
        "rgb(78, 219, 255)",
        "rgb(227, 255, 89)",
        "rgb(183, 0, 255)"
      ],
      defaultGradientColor: [
        ["rgba(51, 120, 255, 1)", "rgba(148, 66, 254, 1)"],
        ["rgba(100, 251, 215, 1)", "rgba(83, 131, 255, 1)"],
        ["rgba(254, 126, 7, 1)", "rgba(255, 222, 103, 1)"],
        ["rgba(193, 92, 255, 1)", "rgba(255, 84, 84, 1)"],
        ["rgba(84, 249, 189, 1)", "rgba(143, 242, 118, 1)"],
        ["rgba(139, 36, 255, 1)", "rgba(239, 58, 255, 1)"],
        ["rgba(100, 181, 255, 1)", "rgba(130, 251, 234, 1)"],
        ["rgba(255, 151, 67, 1)", "rgba(255, 218, 107, 1)"],
        ["rgba(0, 172, 209, 1)", "rgba(109, 229, 255, 1)"],
        ["rgba(203, 4, 183, 1)", "rgba(246, 106, 233, 1)"]
      ],
      fetchEnd: false,
      isBarStyle12: false,
      dataOptions: [{ value: true, title: "本地数据" }, { value: false, title: "数据中心" }],
      appId: null,
      isLocal: true,
      localManual: true,
      source: 1
    }
  },
  mounted() {
    if(this.options.type === "Bar" && this.options.chartOption.styleId === 12){
      this.isBarStyle12 = true
    }
    this.$nextTick(() => {
      // 关闭操作下拉列表
      document.getElementsByClassName("right-toolbar")[0].addEventListener("click", this.closeOpration)
      document.addEventListener("click", this.closeOpration, true)
    })
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    document.getElementsByClassName("right-toolbar")[0].removeEventListener("click", this.closeOpration)
    document.removeEventListener("click", this.closeOpration, true)
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    // 第一维度数据，指series中的data
    seriesDataDimensionOne: {
      get() {
        if (this.options.type == "Radar") {
          return this.hasProperty(this.options, "chartOption.series.0.data")
        } else if (this.options.type == "Gauge") {
          this.activeIndex = 1
          return this.hasProperty(this.options, "chartOption.series")
        } else if (this.options.type == "Pie") {
          // 饼图样式5  半扇饼图  背后的axisLine  是用gauge 画的
          let series = JSON.parse(JSON.stringify(this.hasProperty(this.options, "chartOption.series")))
          let result = []
          series.forEach(item => {
            if (item.type === "pie") {
              for (let i = 0; i < item.data.length; i++) {
                if (item.data[i].value === 0) {
                  item.data.splice(i, 1)
                  i--
                }
              }
              result.push(item)
            }
          })
          return result
        } else if(this.barStyleId === 12){
          let series = JSON.parse(JSON.stringify(this.hasProperty(this.options, "chartOption.series")))
          let result = []
          series.forEach(item => {
            if (item.type === "bar") {
              result.push(item)
            }
          })
          return result
        } else {
          return this.hasProperty(this.options, "chartOption.series")
        }
      }
    },
    //第二维度数据，先看x轴，再看y轴（柱状图、折线图），如果没有的话，说明是没有坐标轴的图表,使用data中的name（饼图）
    seriesDataDimensionTwo: {
      get() {
        let result = []
        if (this.options.chartOption.hasOwnProperty("xAxis")) {
          return this.options.chartOption.xAxis.data && this.options.chartOption.xAxis.data.length > 0
            ? this.options.chartOption.xAxis.data
            : this.options.chartOption.yAxis.data && this.options.chartOption.yAxis.data.length > 0
            ? this.options.chartOption.yAxis.data
            : null
        } else if (this.options.chartOption.hasOwnProperty("radiusAxis")) {
          return this.options.chartOption.radiusAxis.data && this.options.chartOption.radiusAxis.data.length > 0
            ? this.options.chartOption.radiusAxis.data
            : null
        } else if (this.options.type == "Radar") {
          this.options.chartOption.radar.indicator.forEach(item => {
            if (!!item.name) {
              result.push(item.name)
            }
          })
          return result
        } else if (this.options.type === "pie3D") {
          // 3d饼图
          let lastSeries = this.options.chartOption.series[this.options.chartOption.series.length - 1]
          if (!lastSeries) return null
          lastSeries.data.forEach(item => {
            if (!!item.name) {
              result.push(item.name)
            }
          })
          return result
        } else {
          if (Array.isArray(this.options.chartOption.series[this.activeIndex]?.data)) {
            this.options.chartOption.series[this.activeIndex].data.forEach(item => {
              if (!!item.name) {
                result.push(item.name)
              }
            })
            return result
          } else return null
        }
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl ? this.options.restDataUrl : null
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    isDisableAddClassification() {
      // 判断是否不能添加多组数据
      if (this.options.type === "LiquidFill") {
        //水球
        return false
      }
      if (this.options.type === "Gauge") {
        //刻度盘
        return false
      }
      if (this.options.type === "pie3D") {
        //3d 饼图
        return false
      }
      if (
        this.options.type === "Pie" &&
        this.options.chartOption.series.length > 1 &&
        this.options.chartOption.series[1].type !== "pie"
      ) {
        //半圆扇形饼图
        return false
      }
      return true
    },
    barStyleId(){
      let id = 0
      if(this.options.type === "Bar"){
        id = this.options.chartOption.styleId
      }
      return id
    },
    maxAutoSet: {
      get() {
        return this.options.chartOption.maxAutoSet || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.maxAutoSet", false)
      }
    },
    maxAutoValue: {
      get() {
        return this.options.chartOption.maxAutoValue || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.maxAutoValue", false)
      }
    },
    checkStatus() {
      return this.options.appId
    }
  },
  watch: {
    isLocal: {
      handler(newVal) {
        // 手动切换到本地数据
        if(newVal && this.localManual && this.appId && this.source !== 1) {
          this.$confirm("确定使用本地资源？", "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            dangerouslyUseHTMLString: "<p>确定使用本地资源？</p>",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          }).then(() => {
            this.$API.setLocalData({ appId: this.appId, type: "chart_screen" }).then(() => {
              this.isLocal = true
              this.source = 1
              this.$changeOptionsEV("", "dataCenterName", false, null, this.myId, true)
              this.getChartDataLoop()
            })
          }).catch((e) => {
            this.isLocal = false
          })
        }
        this.localManual = true
      }
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (appId === undefined) appId = rectAttr?.options?.appId
      if (!moduleId || !appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时", true)
          .then(res => {
            this.fetchEnd = false
            if (res.appId) {
              // 模板问题，第一次需要手动将数据源切换为本地数据
              this.$API.setLocalData({ appId: res.appId, type: "chart_screen" }).then(() => {
                window.open(`/engine2/data/api-v2/admin/chart_screen/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
                this.restDataUrl = `engine2/data/api-v2/chart/${res.appId}/data`
              })
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (appId) window.open(`/engine2/data/api-v2/admin/chart_screen/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      this.appId = appId
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
    },
    getChartDataLoop() {
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { appId } = rectAttr
      if (appId === undefined) appId = rectAttr?.options?.appId
      if(!appId) {
        return
      }
      this.$changeOptionsEV(appId, "appId", false, null, this.ids)
      this.appId = appId
      if (
        this.restDataUrl &&
        this.restDataUrl.length &&
        this.restDataUrl.slice(this.restDataUrl.indexOf("chart") + 6, -5) !== appId
      ) {
        this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
      }
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      let str = "?w=" + websiteId + "&p=" + pageId
      this.instance.get(this.restDataUrl + str).then(res => {
        allChartDataHandle.oldHandleChartData.call(
          this,
          this.ids?.uid ? rectAttr.chartOption : rectAttr.options.chartOption,
          res,
          this.defaultGradientColor,
          this.defaultColor
        )
      })
    },
    cloneDeep(obj) {
      // 根据obj为对象或者数组，产生一个空的对象或数组，存放数据
      const newobj = obj instanceof Array ? [] : {}
      // for...in进入循环
      for (var k in obj) {
        if (typeof obj[k] === "object") {
          newobj[k] = this.cloneDeep(obj[k])
        } else {
          // 如果数据为基本类型，则直接赋值
          newobj[k] = obj[k]
        }
      }
      // 把存放了数据的新对象返回出去
      return newobj
    },
    /**
     * 2.0预览时候调用此接口判断是否可以预览
     * @param url
     * @param portalData
     */
    requestLoop(url, portalData) {
      const _this = this
      _this.instance.get(`v2/webjson/${portalData.pageId}/html-status?a=${portalData.app}`).then(res => {
        const timer2 = new Date().getTime()
        if (res.data.code == 1) {
          window.open(url)
        } else {
          if (_this.totalTime < 10000) {
            if (timer2 - _this.timer < 3000) {
              let newt = 3000 - (timer2 - _this.timer)
              _this.totalTime += newt
              setTimeout(function () {
                _this.timer = new Date().getTime()
                _this.requestLoop(url, portalData)
              }, newt)
            } else {
              _this.totalTime += timer2 - _this.timer
              _this.timer = new Date().getTime()
              _this.requestLoop(url, portalData)
            }
          } else {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "预览失败",
              type: "error"
            })
          }
        }
      })
    },
    addClassification() {
      // 新增静态数据，默认克隆series第一项
      const temp = JSON.parse(JSON.stringify(this.seriesDataDimensionOne))
      let cloneData = JSON.parse(JSON.stringify(temp[0]))
      // 当柱状图第一条数据变为折线图时 要取默认的柱状图
      if (this.options.type === "Bar" && cloneData.type === "line") {
        const oldData = cloneData.data
        // 复制一个柱状图
        cloneData = JSON.parse(JSON.stringify(chartOption1)).series[0]
        cloneData.data = oldData
        // 如果不删除这个属性折线图重新渲染不出来
        Reflect.deleteProperty(cloneData, "animationDelay")
      }
      cloneData.name = "数据" + (temp.length + 1)
      temp.push(cloneData)
      if (this.options.type === "Radar") {
        this.$changeOptionsEV(temp, "chartOption.series.0.data", false)
      } else {
        this.$changeOptionsEV(temp, "chartOption.series", false)
      }
      // 添加数据系列的时候需要同步图例(饼图不需要操作legend数据)
      if (this.options.type === "Pie" || this.options.type === "Radar") {
        return
      } else {
        const legendTemp = JSON.parse(JSON.stringify(this.options.chartOption.legend))
        let data0 = typeof legendTemp.data[0] === "object" ? legendTemp.data[0] : {}
        legendTemp.data.push({
          ...data0,
          name: cloneData.name
        })
        this.$changeOptionsEV(legendTemp, "chartOption.legend", false)
      }
    },
    activeTabData(flag) {
      if (this.activeIndex === flag) {
        this.oprateShow = !this.oprateShow
      }
      this.activeIndex = flag
    },
    showRenameSeriesDataHandle() {
      this.oprateShow = false
      this.editingFlag = true
    },
    renameSeriesDataHandle(index, name) {
      const temp = JSON.parse(JSON.stringify(this.seriesDataDimensionOne))
      temp[index].name = name
      if (this.options.type === "Radar") {
        this.$changeOptionsEV(temp, "chartOption.series.0.data", false)
      } else {
        this.$changeOptionsEV(temp, "chartOption.series", false)
      }
      // 添加数据系列的时候需要同步图例(饼图不需要操作legend数据)
      if (this.options.type === "Pie" || this.options.type === "Radar") {
        return
      } else {
        const legendTemp = JSON.parse(JSON.stringify(this.options.chartOption.legend))
        if (typeof legendTemp.data[index] == "string") {
          legendTemp.data[index] = name
        } else {
          legendTemp.data[index].name = name
        }
        this.$changeOptionsEV(legendTemp, "chartOption.legend", false)
        this.editingFlag = false
      }
    },
    deleteSeriesDataHandle() {
      let temp = JSON.parse(JSON.stringify(this.seriesDataDimensionOne))
      temp.splice(this.activeIndex, 1)
      if (this.options.type === "Radar") {
        this.$changeOptionsEV(temp, "chartOption.series.0.data", false)
      } else {
        this.$changeOptionsEV(temp, "chartOption.series", false)
      }
      // this.activeIndex = 0
      // 添加数据系列的时候需要同步图例(饼图不需要操作legend数据)
      if (this.options.type === "Pie" || this.options.type === "Radar") {
        return
      } else {
        const legendTemp = JSON.parse(JSON.stringify(this.options.chartOption.legend.data))
        legendTemp.splice(this.activeIndex, 1)
        this.$changeOptionsEV(legendTemp, "chartOption.legend.data", false)
      }
    },
    moveSeriesDataHandle(type, index) {
      const legendTemp = this.options.chartOption.legend.data
      let temp = this.seriesDataDimensionOne
      if (type === 1) {
        if (index > 0) {
          temp.splice(index, 1, ...temp.splice(index - 1, 1, temp[index]))
          if (legendTemp) {
            legendTemp.splice(index, 1, ...legendTemp.splice(index - 1, 1, legendTemp[index]))
          }
          this.activeIndex = index - 1
        }
      } else {
        if (index < temp.length - 1) {
          temp.splice(index, 1, ...temp.splice(index + 1, 1, temp[index]))
          if (legendTemp) {
            legendTemp.splice(index, 1, ...legendTemp.splice(index + 1, 1, legendTemp[index]))
          }
          this.activeIndex = index + 1
        }
      }
      this.oprateShow = false
      this.$changeOptionsEV(legendTemp, "chartOption.legend.data", false)
      this.$changeOptionsEV(temp, "chartOption.series", false)
      this.$changeOptionsEV(true, "chartOption.reload", false)
    },
    closeOpration() {
      this.oprateShow = false
    },
    onDataCenterChange() {
      this.getChartDataLoop()
    },
    onAfterDataCenterChoose(appId) {
      this.appId = appId
      this.restDataUrl = `engine2/data/api-v2/chart/${appId}/data`
    },
    onBeforeDataCenterUpdate() {
      this.localManual = false
      this.isLocal = true
    },
    onAfterDataCenterUpdate(source) {
      this.localManual = false
      this.source = source
      this.isLocal = source === 1
    },
    updateToolbarData() {
      this.getChartDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.title500_16_22 {
  color: inherit;
}
.data-source-type {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.data-source-type::v-deep .el-radio {
  margin-bottom: 16px;
}
.data-source-type::v-deep .el-radio__inner {
  background-color: rgba(255, 255, 255, 0);
}
.dataContent {
  font-size: 14px;
  line-height: 22px;
  color: rgba(255, 255, 255, 0.8);
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.dataTabs {
  width: 228px;
  display: flex;
  border: 1px solid var(--borderColorSeven);
  overflow-x: auto;
  overflow-y: visible;
  padding-top: 180px;
  margin-top: -180px;
}
.dataTabs .dataTabItem {
  font-size: 13px;
  line-height: 22px;
  color: var(--textColor);
  background: var(--dataTableAddBgColor);
  padding: 7px 8px 7px 13px;
  cursor: pointer;
  border-right: 1px solid var(--borderColorSeven);
  position: relative;
}
.dataTabs .dataTabItem .icon-portal-down-one {
  color: var(--toolbarTipText);
}
.dataTabs .dataTabItem.active {
  background: var(--dataAddActiveBgColor);
}
.dataTabs .dataTabItem .value-viewer {
  margin-right: 6px;
}
.dataTabs .addClassification {
  padding: 12px 16px;
  cursor: pointer;
  text-align: center;
  background: var(--dataTableAddBgColor);
  border-right: 1px solid var(--borderColorSeven);
}
.dataTabs .addClassification .icon-portal-icon-add::before {
  color: var(--subTextColor);
}
.dataTableOperate {
  position: absolute;
  bottom: 40px;
  left: 0;
  border: 1px solid var(--borderColorTen);
  box-shadow: var(--operateBoxShadow);
}
.dataTableOperate_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 12px;
  width: 72px;
  height: 40px;
  background: var(--dialogBgColor);
  color: var(--textColor);
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}
.dataTabs .data-editor {
  display: block;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  width: 84px;
  text-align: left;
  padding: 0 2px;
  overflow: hidden;
  white-space: nowrap;
  background: none;
  outline: none !important;
  border: 0;
  color: #ffffff;
  color: var(--textColor);
}
</style>
